module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1171.a8ba8766.png";